import { BaseDHFSection } from "./client/plugins/DocumentSections/BaseDHFSection";
import { IDHFControlDefinition, IDHFSection } from "./common/businesslogic";
import { IBaseControlOptions } from "./common/UI/Controls/BaseControl";
import { app, IReference } from "./globals";
import { ItemSelectionFromToImpl } from "./common/UI/Controls/itemSelectionFromTo";
import { SelectSearchQueue } from "./SelectSearchQueue";
import { ml } from "./common/matrixlib";
import { IDoubleSelectOptions } from "./SingleSelectBase";

abstract class DoubleSelectBase<T extends IDoubleSelectOptions> extends BaseDHFSection<T> implements IDHFSection {
    abstract renderControl(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions): void;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    addSignatures(signatures: string[], currentValue: IDHFControlDefinition) {}

    abstract showSpecificSettings(
        ctrl: IDHFControlDefinition,
        ctrlParameter: IBaseControlOptions,
        custom: JQuery,
    ): void;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected addSpecificSettings(controllerConfig: T, custom: JQuery) {
        let searchFrom = $(
            '<input autocomplete="off" style="height: 20px;width: 420px;float: right;" class="form-control p_searchFrom" type="text" name="search" value="" /> ',
        );
        const sp = $("<div class='sectionConfOption'>Find from items by search: </div>").append(searchFrom);
        custom.append(sp);
        searchFrom.val(controllerConfig.searchFrom ? controllerConfig.searchFrom : "");

        let searchTo = $(
            '<input autocomplete="off" style="height: 20px;width: 420px;float: right;" class="form-control p_searchTo" type="text" name="search" value="" /> ',
        );
        const sp2 = $("<div class='sectionConfOption'>Find to items by search: </div>").append(searchTo);
        custom.append(sp2);
        searchTo.val(controllerConfig.searchTo ? controllerConfig.searchTo : "");
    }

    abstract saveSpecificSettingsAsync(
        ctrl: IDHFControlDefinition,
        ctrlParameter: IBaseControlOptions,
        custom: JQuery,
    ): Promise<boolean>;

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected setSpecificSettings(controllerConfig: IDoubleSelectOptions, custom: JQuery) {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        let changed = controllerConfig.searchFrom != $(custom.find(".p_searchFrom")[0]).val();
        controllerConfig.searchFrom = $(custom.find(".p_searchFrom")[0]).val();

        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        changed = changed || controllerConfig.searchTo != $(custom.find(".p_searchTo")[0]).val();
        controllerConfig.searchTo = $(custom.find(".p_searchTo")[0]).val();

        return changed;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    hasSearch(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);
        return !!controllerConfig.searchFrom || !!controllerConfig.searchTo;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    executeSearch(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);

        let rn = $(".refreshNeeded", ctrl.control).removeClass("refreshNeeded");

        if (controllerConfig.searchFrom) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            app.searchAsyncMinimalOutput(controllerConfig.searchFrom, null, true).done(function (itemIds) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (itemIds.length == 0) {
                    rn.addClass("refreshNeeded");
                } else {
                    // We have items, so we don't need to have the contentNeeded class.
                    $(".contentNeeded", ctrl.control).removeClass("contentNeeded");
                }

                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                (<ItemSelectionFromToImpl>ctrl.control.getController()).setValueFrom(itemIds);
            });
        }
        if (controllerConfig.searchTo) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            app.searchAsyncMinimalOutput(controllerConfig.searchTo, null, true).done(function (itemIds) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (itemIds.length == 0) {
                    rn.addClass("refreshNeeded");
                }
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                (<ItemSelectionFromToImpl>ctrl.control.getController()).setValueTo(itemIds);
            });
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifySearchAsync(ctrl: IDHFControlDefinition) {
        let controllerConfig = this.getConfig(ctrl);

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let lastValue = await ctrl.control.getController().getValueAsync();
        let lastVal = lastValue ? JSON.parse(lastValue) : { from: [], to: [] };

        let rn = $(".refreshNeeded", ctrl.control).removeClass("refreshNeeded");
        if (controllerConfig.searchFrom) {
            $(".fa-sync-alt", ctrl.control).addClass("icon-refresh-animate");
            SelectSearchQueue.addToSearchQueue(() => {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return app.searchAsyncMinimalOutput(controllerConfig.searchFrom, null, true).done(function (current) {
                    $(".fa-sync-alt", ctrl.control).removeClass("icon-refresh-animate");
                    let last: IReference[] = lastVal.from;
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (current.length == 0) {
                        rn.addClass("refreshNeeded");
                        return;
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                    } else if (last.length != current.length) {
                        rn.addClass("refreshNeeded");
                        return;
                    } else {
                        let lastItems = last
                            .map(function (lastItem) {
                                return lastItem.to;
                            })
                            .sort(function (a, b) {
                                return ml.Item.sort(a, b);
                            });
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        let currentItems = current.sort(function (a, b) {
                            return ml.Item.sort(a, b);
                        });
                        for (let idx = 0; idx < lastItems.length; idx++) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (lastItems[idx] != currentItems[idx]) {
                                rn.addClass("refreshNeeded");
                                return;
                            }
                        }
                    }
                });
            });
        }

        if (controllerConfig.searchTo) {
            $(".fa-sync-alt", ctrl.control).addClass("icon-refresh-animate");
            SelectSearchQueue.addToSearchQueue(() => {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return app.searchAsyncMinimalOutput(controllerConfig.searchTo, null, true).done(function (current) {
                    $(".fa-sync-alt", ctrl.control).removeClass("icon-refresh-animate");
                    let last: IReference[] = lastVal.to;
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (current.length == 0) {
                        rn.addClass("refreshNeeded");
                        return;
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        // TODO: MATRIX-7555: lint errors should be fixed for next line
                        // eslint-disable-next-line
                    } else if (last.length != current.length) {
                        rn.addClass("refreshNeeded");
                        return;
                    } else {
                        let lastItems = last
                            .map(function (lastItem) {
                                return lastItem.to;
                            })
                            .sort(function (a, b) {
                                return ml.Item.sort(a, b);
                            });
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        let currentItems = current.sort(function (a, b) {
                            return ml.Item.sort(a, b);
                        });
                        for (let idx = 0; idx < lastItems.length; idx++) {
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            if (lastItems[idx] != currentItems[idx]) {
                                rn.addClass("refreshNeeded");
                                return;
                            }
                        }
                    }
                });
            });
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifyContentAsync(ctrl: IDHFControlDefinition) {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let lastValue = await ctrl.control.getController().getValueAsync();
        let lastVal = lastValue ? JSON.parse(lastValue) : { from: [], to: [] };
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (lastVal.from.length == 0 || lastVal.to.length == 0) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ctrl.control.closest(".ft_dhf").find(".baseControlHelp").addClass("contentNeeded");
        } else {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ctrl.control.closest(".ft_dhf").find(".baseControlHelp").removeClass("contentNeeded");
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected removeSpaces(str: string) {
        if (!str) {
            return "";
        }
        return str
            .split("|")
            .map(function (strp) {
                return strp.trim();
            })
            .join("|")
            .split(",")
            .map(function (strp) {
                return strp.trim();
            })
            .join(",");
    }
}

export { DoubleSelectBase };
